import { application } from "./application"

import AutoSubmit from "@stimulus-components/auto-submit"
application.register("auto-submit", AutoSubmit)

import CalEmbedController from "./cal_embed_controller"
application.register("cal-embed", CalEmbedController)

import ConsultationWizardController from "./consultation_wizard_controller"
application.register("consultation-wizard", ConsultationWizardController)

import NavController from "./nav_controller"
application.register("nav", NavController)

import ScrollIntoViewController from "./scroll_into_view_controller"
application.register("scroll-into-view", ScrollIntoViewController)

import ConditionalFieldController from "./conditional_field_controller"
application.register("conditional-field", ConditionalFieldController)

import FileUploadController from "./file_upload_controller"
application.register("file-upload", FileUploadController)

import RepeatableGroupController from "./repeatable_group_controller"
application.register("repeatable-group", RepeatableGroupController)

import SectionNavController from "./section_nav_controller"
application.register("section-nav", SectionNavController)

import StoryCardController from "./story_card_controller"
application.register("story-card", StoryCardController)

import ReviewerPickerController from "./reviewer_picker_controller"
application.register("reviewer-picker", ReviewerPickerController)

import SlidesController from "./slides_controller"
application.register("slides", SlidesController)

import DeckEditorController from "./deck_editor_controller"
application.register("deck-editor", DeckEditorController)

import WheelController from "./wheel_controller"
application.register("wheel", WheelController)
